'use client';

import * as React from 'react';
import { cn } from '~/lib/utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded border-none shadow ring-1 ring-primary-400/10 data-[state=checked]:bg-primary-400 data-[state=checked]:ring-primary-200 dark:bg-zinc-700',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center')}>
      {/* <Check className="h-4 w-4 text-white" /> */}
      <span data-state="checked" className="pointer-events-none">
        <svg width="10" height="10" viewBox="-0.25 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.75 5.46429L4.07143 8.25C5.46429 4.76786 8.25 1.75 8.25 1.75"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </span>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
